import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { Button } from '@mui/material'
// import brokenErrorImage from '~/assets/broken-error.webp'
import Result from './Result'

const PageBoundary = () => {
  const { t } = useTranslation()

  const extra = useMemo(() => {
    return (
      <Button
        variant="contained"
        color="primary"
        size="large"
        onClick={() => {
          window.location.reload()
        }}
      >
        {t('ui.cta.refresh')}
      </Button>
    )
  }, [t])

  return (
    <Result
      extra={extra}
      // status={<img src={brokenErrorImage} alt={t('broken error')} />}
      title={t('error.unknown.title')}
      // subTitle={t('React Error')}
      description={t('error.unknown.description')}
    />
  )
}

export default PageBoundary
